import React, { useState } from 'react';
import { getDeviceHistory } from '../../../api/product-api';
import { IPatientDevice } from '../../../models/product-detail';
import TextInput from '../../inputs/text-input';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';
interface Props {
    onChange: (serialNumber: string | null) => void;
    name: string;
    productStyle: string;
    error?: string;
}

const SerialNumberLookup: React.FC<Props> = ({
    onChange,
    name,
    productStyle,
    error,
}) => {
    const intl = useIntl();
    let wrapperClass = 'form-group';
    if (error && error.length > 0) {
        wrapperClass += ' has-error';
    }

    const [lookupMessage, setlookupMessage] = useState<boolean>(false);
    const [serialNumberState, setSerialNumberState] = useState<string>();
    const [deviceState, setDeviceState] = useState<IPatientDevice>();
    const [errorMessage, setErrorMessage] = useState<string>();

    const validateDevice = async () => {
        if (serialNumberState!.length > 0) {
            setlookupMessage(true);
            // TODO: Move to a hook
            const device = await getDeviceHistory(serialNumberState!);

            if (device.data && device.data.device) {
                if (productStyle.includes(device.data!.device.style)) {
                    setDeviceState(device.data!);
                    onChange(device.data!.device.serialNumber);
                    setErrorMessage(undefined);
                } else {
                    setErrorMessage(`Invalid device style`);
                    setDeviceState(undefined);
                    onChange(null);
                }
            } else {
                setDeviceState(undefined);
                onChange(null);
                setErrorMessage('Invalid serial number');
            }
            setlookupMessage(false);
        } else {
            setDeviceState(undefined);
            onChange(null);
            setErrorMessage(undefined);
        }
    };

    return (
        <>
            <div className={`col-sm-12 ${wrapperClass}`}>
                <div className="col-sm-11">
                    <TextInput
                        label={`Serial number of the device that will pair with this new
                        device`}
                        name={name}
                        value={serialNumberState}
                        labelClassName="col-sm-12"
                        fieldClassName="col-sm-12"
                        onChange={(e) => setSerialNumberState(e.target.value)}
                        onBlur={validateDevice}
                        required={true}
                        customLabel={true}
                    />
                </div>
            </div>
            <div className="col-sm-12">
                {lookupMessage && <p>Looking up...</p>}
                {deviceState && deviceState.device ? (
                    <>
                        <p className={'font-green'}>
                            <span className="fad fa-check" />{' '}
                            {` ${intl.formatMessage({
                                id: 'Style',
                                defaultMessage: 'Style',
                            })}: ${
                                deviceState.device.style
                            }, ${intl.formatMessage({
                                id: 'Directional',
                                defaultMessage: 'Directional',
                            })}:${
                                deviceState.device.options &&
                                deviceState.device.options.includes(
                                    'Directional Microphone'
                                )
                                    ? intl.formatMessage({
                                          id: 'Yes',
                                          defaultMessage: 'Yes',
                                      })
                                    : intl.formatMessage({
                                          id: 'No',
                                          defaultMessage: 'No',
                                      })
                            },  ${intl.formatMessage({
                                id: 'Matrix',
                                defaultMessage: 'Matrix',
                            })}:${
                                deviceState.device.matrix
                                    ? deviceState.device.matrix.split('/')[0]
                                    : intl.formatMessage({
                                          id: 'Not/Applicable',
                                          defaultMessage: 'N/A',
                                      })
                            }`}
                        </p>
                    </>
                ) : (
                    <>
                        {errorMessage && (
                            <p className="font-error">
                                {intl.formatMessage({
                                    id: errorMessage.replace(/ /g, '_'),
                                    defaultMessage: errorMessage,
                                })}
                            </p>
                        )}
                    </>
                )}
            </div>
        </>
    );
};

export default SerialNumberLookup;
